export default "__VITE_ASSET__DfZuuOkV__"